<!-- footer.vue -->
<template>
	<div
			class="ui-detail-footer"
			v-if="detailInfo"
			v-bind:class="{
			'hidden-cart-footer': ispromotion,
			'show-cart-footer': !ispromotion
		}"
	>
		<div class="footer-flex">
			<div class="left">
				<div class="item" v-on:click="$router.push({name:'HomeStoredetail',query:{id:storeInfo.store_id}})">
					<span class="iconfont">&#xe69f;</span>
					<span class="text">Shop</span>
				</div>
<!--				<div class="item" v-if="config && config.instant_message_open == '1' && config.instant_message_gateway_url" v-on:click="goChat()">
					<span class="iconfont">&#xe6f1;</span>
					<span class="text">customer service</span>
				</div>-->

        <div class="item" v-on:click="show_service()">
          <span class="iconfont">&#xe6f1;</span>
          <span class="text">Service</span>
        </div>

				<div class="item" v-on:click="goCart()">
					<span class="iconfont">&#xe6ae;</span>
					<span class="icon" v-if="cartNumber > 0">{{ getCarCount }}</span>
					<span class="text">Cart</span>
				</div>
			</div>
			<div class="right">
				<div
						class="button "
						:class="canBuy?'active-cart':'disabled-cart'"
						v-on:click="addShopping(true)"
						v-if="!detailInfo.bargain_info && ((!detailInfo.pintuan_type && detailInfo.cart) || (detailInfo.pintuan_type && detailInfo.pintuangroup_list.length))"
				>
					{{addCartText}}
				</div>
				<div
						class="button "
						:class="canSample?'active-sample':'disabled-cart'"
						v-on:click="showSample()"
						v-if="canSample"
				>
          Get sample
				</div>
				<div
						class="button "
						:class="canBuy?'active-buy':'disabled-buy'"
						v-on:click="checkout()"
				>
					{{buyNowText}}
				</div>
			</div>
		</div>
		<p class="good-stock-none" v-if="detailInfo.goods_state != 1 || detailInfo.goods_verify!=1">
      The selected product has been removed, sorry!
		</p>
		<p class="good-stock-none" v-else-if="detailInfo.goods_storage <= 0">
      The selected product is temporarily out of stock, sorry!
		</p>
		<shopping v-if="isShowcartInfo" :isShowcartInfo="isShowcartInfo"></shopping>
		<!-- 加入购物车显示动画 -->
		<div class="ui-cart-animation" v-if="isAnimation">
			<mt-spinner type="snake" color="#e93b3d"></mt-spinner>
		</div>

    <mt-popup
      class="sample-popup"
      v-model="isShowSampleInfo"
      position="bottom"
      v-if="detailInfo"
    >
      <div class="sample-panel">
        <div class="sample-header">
          <div>
            <div class="sample-title">Get sample</div>
            <div class="sample-subtitle">Max quantity per request: {{ sampleMaxQuantity }}</div>
          </div>
          <span class="iconfont close" v-on:click="closeSample()">&#xe65a;</span>
        </div>
        <div class="sample-body">
          <div class="sample-goods-name">{{ detailInfo.goods_name }}</div>
          <div v-if="sampleWarehouseRequired" class="sample-warehouse">
            <div class="sample-warehouse-title">Ship from</div>
            <div v-if="warehouseList.length" class="sample-warehouse-list">
              <button
                v-for="warehouse in warehouseList"
                :key="warehouse.warehouse_id"
                type="button"
                :class="{ active: sampleWarehouseId === warehouse.warehouse_id }"
                @click="selectSampleWarehouse(warehouse)"
              >
                {{ warehouse.country_name }} - {{ warehouse.warehouse_name }} ({{ warehouse.goods_storage }})
              </button>
            </div>
            <div v-else class="sample-warehouse-empty">No warehouse stock</div>
          </div>
          <div class="sample-row" v-for="item in sampleRows" :key="item.goods_id">
            <div class="sample-row-info">
              <div class="sample-spec">{{ formatSampleSpec(item.goods_spec) }}</div>
              <div class="sample-price">Sample price: ${{ item.sample_price }}</div>
              <div class="sample-stock">Stock: {{ getSampleStock(item) }} pieces</div>
            </div>
            <div class="sample-number">
              <div
                class="sample-control"
                v-bind:class="{ 'sample-control-disabled': getSampleQuantity(item.goods_id) <= 0 }"
                @click.stop="changeSampleQuantity(item, -1)"
              >
                -
              </div>
              <input
                type="number"
                min="0"
                v-model.number="sampleQuantities[item.goods_id]"
                @change="sampleInputChange(item)"
              />
              <div
                class="sample-control"
                v-bind:class="{ 'sample-control-disabled': !canIncreaseSample(item) }"
                @click.stop="changeSampleQuantity(item, 1)"
              >
                +
              </div>
            </div>
          </div>
        </div>
        <div class="sample-error">{{ sampleError }}</div>
        <div class="sample-footer">
          <div class="sample-total">Total: <span>${{ sampleTotalAmount }}</span></div>
          <div class="sample-buy" @click="sampleBuyNow()">Buy now</div>
        </div>
      </div>
    </mt-popup>

    <div>
      <mt-popup class="service_popup" v-model="EditService" position="bottom">
        <div class="kefu_list">
          <a href="https://api.whatsapp.com/send?phone=+8615816888586&amp;text=Hello!" target="_blank">
            <img src="../../../assets/image/contact/whatsapp.png">
          </a>
          <a href="https://www.facebook.com/profile.php?id=100083351816540&amp;sk=about" target="_blank">
            <img src="../../../assets/image/contact/facebook.png">
          </a>
          <a href="https://twitter.com/qana123" target="_blank">
            <img src="../../../assets/image/contact/twitter.png">
          </a>
          <a href="https://www.tiktok.com/@qana_group?lang=zh-Hant-TW" target="_blank">
            <img src="../../../assets/image/contact/tiktok.png">
          </a>
          <a href="https://www.youtube.com/channel/UCYsho6fzzPxpbLJcqs1xlSw" target="_blank">
            <img src="../../../assets/image/contact/youtube.png">
          </a>
          <a href="https://www.instagram.com/qanagroup8/" target="_blank">
            <img src="../../../assets/image/contact/instagram.png">
          </a>
          <a href="javascript:void(0);" v-if="config && config.instant_message_open == '1' && config.instant_message_gateway_url" v-on:click="goChat()">
            <img src="../../../assets/image/contact/online.png">
          </a>
        </div>
      </mt-popup>
    </div>

	</div>

</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import shopping from './child/Shopping'
import { cartQuantity } from '../../../api/homecart'
import { addBargain } from '../../../api/memberBargain'
export default {
  data () {
    return {
      addCartText: 'Add to cart',
      buyNowText: 'Buy now',
      cartNumber: 0,
      isAnimation: false, // 加入购物车成功之后是否显示动画
      EditService: false,
      isShowSampleInfo: false,
      sampleQuantities: {},
      sampleError: '',
      sampleWarehouseId: 0
    }
  },
  components: {
    shopping
  },
  props: {
    ishidefooter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      user: state => state.member.info,
      // 是否显示购物车浮层
      isShowcartInfo: state => state.goodsdetail.isShowcartInfo,
      storeInfo: state => state.goodsdetail.storeInfo,
      detailInfo: state => state.goodsdetail.detailInfo,
      specList: state => state.goodsdetail.specList,
      warehouseList: state => state.goodsdetail.warehouseList,
      isOnline: state => state.member.isOnline,
      ispromotion: state => state.goodsdetail.ispromotion,
      // cartNumber: state => state.tabBar.cartNumber,
      chooseinfo: state => state.goodsdetail.chooseinfo,
      number: state => state.goodsdetail.number
    }),
    canBuy () {
      if (this.detailInfo.goods_storage > 0 && this.detailInfo.goods_state == 1 && this.detailInfo.goods_verify == 1) {
        return true
      } else {
        return false
      }
    },
    canSample () {
      return this.canBuy && this.detailInfo.is_sample_support == 1 && this.sampleMaxQuantity > 0 && this.sampleRows.length > 0
    },
    sampleWarehouseRequired () {
      return Number(this.detailInfo.warehouse_stock_enabled) === 1
    },
    sampleMaxQuantity () {
      return parseInt(this.detailInfo.sample_max_quantity) || 0
    },
    sampleRows () {
      let rows = []
      let sampleGoodsList = this.detailInfo.sample_goods_list
      if (Array.isArray(sampleGoodsList)) {
        rows = sampleGoodsList
      } else if (sampleGoodsList) {
        for (let key in sampleGoodsList) {
          rows.push(sampleGoodsList[key])
        }
      }
      if (!rows.length) {
        rows = [{
          goods_id: this.detailInfo.goods_id,
          goods_spec: this.detailInfo.goods_spec,
          goods_storage: this.detailInfo.goods_storage,
          sample_price: this.detailInfo.sample_price
        }]
      }
      return rows.filter(item => parseFloat(item.sample_price) > 0)
    },
    sampleTotalQty () {
      let total = 0
      this.sampleRows.forEach(item => {
        total += this.getSampleQuantity(item.goods_id)
      })
      return total
    },
    sampleTotalAmount () {
      let total = 0
      this.sampleRows.forEach(item => {
        total += this.getSampleQuantity(item.goods_id) * (parseFloat(item.sample_price) || 0)
      })
      return total.toFixed(2)
    },
    getCarCount () {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber
      } else if (this.cartNumber >= 100) {
        return '99+'
      }
    }
  },
  watch: {
    warehouseList: {
      immediate: true,
      handler (warehouseList) {
        if (this.sampleWarehouseRequired && warehouseList.length) {
          this.sampleWarehouseId = warehouseList[0].warehouse_id
        } else if (this.sampleWarehouseRequired) {
          this.sampleWarehouseId = 0
        }
      }
    }
  },
  created () {
    if (this.detailInfo.bargain_info) {
      if (this.detailInfo.bargainorder_info) {
        if (this.detailInfo.bargainorder_info.bargainorder_state == 2) {
          this.buyNowText = 'Successfully bargain to place an order'
        } else {
          this.buyNowText = 'Bargaining'
        }
      } else {
        this.buyNowText = 'Initiate bargaining'
      }
    } else if (this.detailInfo.pintuan_type) {
      this.addCartText = 'Join a group'
      this.buyNowText = 'Start the group immediately'
    } else if (this.detailInfo.is_presell == 1) {
      this.buyNowText = 'Pre-sale purchase(' + this.$moment.unix(this.detailInfo.presell_deliverdate).format('YYYY-MM-DD') + ' delivery）'
    } else if (this.detailInfo.is_goodsfcode == 1) {
      this.buyNowText = 'F code purchase'
    }
    this.$on('start-addcart-animation', () => {
      this.isAnimation = true
    })
    this.$on('end-addcart-animation', () => {
      this.isAnimation = false
      this.saveCartState(false)
    })
    this.getCartCount()
    this.$on('update-cart-num', () => {
      this.getCartCount()
    })
  },
  methods: {
    ...mapMutations({
      saveCartState: 'saveCartState',
      changeType: 'changeType',
      saveSelectedCartGoods: 'saveSelectedCartGoods'
    }),
    goChat () {
      if (!this.user) {
        Toast('Please log in first')
        this.$router.push({ name: 'HomeMemberLogin' })
      } else if (this.user.member_id == this.storeInfo.member_id) {
        Toast('Cannot chat with myself')
      } else {
        this.$router.push({ name: 'MemberChatInfo', query: { t_id: this.storeInfo.member_id, t_name: this.storeInfo.store_name, goods_id: this.detailInfo.goods_id } })
      }
    },
    show_service () {
      this.EditService = true
      return false
    },
    showSample () {
      if (!this.canSample) {
        return
      }
      if (!this.user) {
        Toast('Please log in first')
        this.$router.push({ name: 'HomeMemberLogin' })
        return
      }
      if (this.user.store_id == this.storeInfo.store_id) {
        Toast('Cannot buy own products')
        return
      }
      this.initSampleQuantities()
      this.sampleError = ''
      this.isShowSampleInfo = true
    },
    closeSample () {
      this.isShowSampleInfo = false
    },
    initSampleQuantities () {
      this.sampleRows.forEach(item => {
        if (typeof (this.sampleQuantities[item.goods_id]) === 'undefined') {
          this.$set(this.sampleQuantities, item.goods_id, 0)
        }
      })
    },
    formatSampleSpec (spec) {
      let values = []
      if (spec) {
        for (let key in spec) {
          values.push(spec[key])
        }
      }
      return values.length ? values.join(' / ') : 'Default'
    },
    getSampleQuantity (goodsId) {
      return parseInt(this.sampleQuantities[goodsId]) || 0
    },
    getSampleOtherTotal (goodsId) {
      let total = 0
      this.sampleRows.forEach(item => {
        if (item.goods_id != goodsId) {
          total += this.getSampleQuantity(item.goods_id)
        }
      })
      return total
    },
    canIncreaseSample (item) {
      let stock = this.getSampleStock(item)
      return this.getSampleQuantity(item.goods_id) < stock && this.sampleTotalQty < this.sampleMaxQuantity
    },
    getSampleStock (item) {
      if (this.sampleWarehouseRequired) {
        let warehouse = this.warehouseList.find(item => item.warehouse_id === this.sampleWarehouseId)
        return warehouse ? (parseInt(warehouse.goods_storage) || 0) : 0
      }
      return parseInt(item.goods_storage) || 0
    },
    selectSampleWarehouse (warehouse) {
      this.sampleWarehouseId = warehouse ? warehouse.warehouse_id : 0
      this.sampleRows.forEach(item => this.sampleInputChange(item))
    },
    changeSampleQuantity (item, delta) {
      if (delta > 0 && !this.canIncreaseSample(item)) {
        return
      }
      let goodsId = item.goods_id
      this.$set(this.sampleQuantities, goodsId, this.getSampleQuantity(goodsId) + delta)
      this.sampleInputChange(item)
    },
    sampleInputChange (item) {
      let goodsId = item.goods_id
      let quantity = this.getSampleQuantity(goodsId)
      let stock = this.getSampleStock(item)
      let otherTotal = this.getSampleOtherTotal(goodsId)
      let maxQuantity = this.sampleMaxQuantity
      let maxAllowed = stock
      if (maxQuantity > 0) {
        maxAllowed = Math.min(stock, Math.max(maxQuantity - otherTotal, 0))
      }
      if (quantity < 0) {
        quantity = 0
      }
      if (quantity > maxAllowed) {
        quantity = maxAllowed
      }
      this.$set(this.sampleQuantities, goodsId, quantity)
      this.updateSampleError(false)
    },
    updateSampleError (showEmpty) {
      if (this.sampleTotalQty > this.sampleMaxQuantity) {
        this.sampleError = 'Total quantity cannot exceed max sample quantity ' + this.sampleMaxQuantity
      } else if (showEmpty && this.sampleTotalQty <= 0) {
        this.sampleError = 'Please enter quantity'
      } else {
        this.sampleError = ''
      }
    },
    sampleBuyNow () {
      if (this.sampleWarehouseRequired && !this.sampleWarehouseId) {
        this.sampleError = 'Please select a shipping warehouse'
        return
      }
      this.updateSampleError(true)
      if (this.sampleError) {
        return
      }
      let cartIds = []
      this.sampleRows.forEach(item => {
        let quantity = this.getSampleQuantity(item.goods_id)
        if (quantity > 0) {
          cartIds.push(item.goods_id + '|' + quantity)
        }
      })
      if (!cartIds.length) {
        this.sampleError = 'Please enter quantity'
        return
      }
      let params = { buy_now: 1, cart_id: cartIds.join(','), is_sample: 1 }
      if (this.sampleWarehouseRequired) {
        params.warehouse_id = this.sampleWarehouseId
      }
      this.$router.push({ name: 'MemberBuyStep1', query: params })
    },
    getCartCount () {
      if (this.isOnline) {
        cartQuantity().then(res => {
          if (res) {
            this.cartNumber = res.result.cart_count
          }
        })
      }
    },
    // 加入购物车
    addShopping (value) {
      this.saveCartState(value)
      this.changeType('Determine')
    },
    // 立即购买
    checkout () {
      if (!this.canBuy) {
        return
      }
      if (this.specList && Object.keys(this.specList).length > 1) {
        this.addShopping(true)
        return
      }
      if (this.user) {
        if (this.user.store_id == this.storeInfo.store_id) {
          Toast('Cannot buy own products')
          return
        }
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
        return
      }
      if (this.detailInfo.is_virtual == '1') {
        let params = { goods_id: this.detailInfo.goods_id, quantity: 1 }
        if (this.detailInfo.pintuan_type) {
          params['pintuan_id'] = this.detailInfo.pintuan_id
          params['pintuangroup_id'] = 0
        }
        this.$router.push({ name: 'MemberVrBuyStep1', query: params })
      } else {
        if (this.detailInfo.wholesale_info.minorder) {
          var params = { buy_now: 1, cart_id: this.detailInfo.goods_id + '|' + this.detailInfo.wholesale_info.minorder }
        } else {
          var params = { buy_now: 1, cart_id: this.detailInfo.goods_id + '|1' }
        }

        if (this.detailInfo.bargain_info) {
          if (this.detailInfo.bargainorder_info) {
            if (this.detailInfo.bargainorder_info.bargainorder_state == 2) {
              params['bargainorder_id'] = this.detailInfo.bargainorder_info.bargainorder_id
            } else {
              this.$router.push({ name: 'HomeBargainshare', query: { bargainorder_id: this.detailInfo.bargainorder_info.bargainorder_id } })
              return
            }
          } else {
            // 新增砍价
            addBargain(this.detailInfo.bargain_info.bargain_id).then(res => {
              this.$router.push({ name: 'HomeBargainshare', query: { bargainorder_id: res.result.bargainorder_id } })
            }).catch(function (error) {
              Toast(error.message)
            })
            return
          }
        } else if (this.detailInfo.pintuan_type) {
          params['pintuan_id'] = this.detailInfo.pintuan_id
          params['pintuangroup_id'] = 0
        }

        /* console.log(params)
        return false */

        this.$router.push({ name: 'MemberBuyStep1', query: params })
      }
    },
    // 购物车
    goCart () {
      if (this.isOnline) {
        this.$router.push({ name: 'HomeCart', params: { type: 0 } })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },
    /*
     * fromatArray: 格式化数组
     */
    fromatArray (delimiter, arrays) {
      let data = ''
      if (delimiter) {
        data = arrays.join(delimiter)
      }
      return delimiter ? data : arrays
    },
    /*
     * isHasStock: 是否还有库存
     */
    isHasStock (id) {
      let data = this.detailInfo.stock
      if (data.length > 0) {
        for (let i = 0, len = data.length; i <= len - 1; i++) {
          if (data[i].goods_attr == id) {
            return '' + data[i].stock_number + ''
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
	.ui-detail-footer {
		background: rgba(255, 255, 255, 1);
		border-top: 0.5px solid #e8eaed;
		width: auto;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 0;
		&.hidden-cart-footer {
			display: none;
		}
		&.show-cart-footer {
			display: block;
		}
		.footer-flex {
			display: flex;
			justify-content: space-between;
			align-content: center;
			align-items: center;
			height: 2.2rem;
		}
		p.good-stock-none {
			width: 100%;
			height: 1.6rem;
			background: #c3c3c3;
			opacity: 0.5;
			font-size: 0.7rem;
			color: #333;
			position: absolute;
			text-align: center;
			line-height: 1.6rem;
			padding: 0;
			margin: 0;
			bottom: 2.2rem;
		}
		div.left {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 7.5rem;
			.item{flex:1;text-align: center;line-height: 1;position:relative;
				.iconfont {
					flex-shrink: 0;
					font-size:1.3rem;

				}
				.text{font-size:.5rem;color:gray;display: block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis}
			}
			span.icon {
				position: absolute;
				right: 0;
				top: 0;
				font-size: 0.5rem;
				line-height: 0.7rem;
				width: 0.9rem;
				height: 0.7rem;
				background: #ef3338;
				border-radius: 1rem;
				text-align: center;
				color: #ffffff;
			}
		}
		div.right {
			flex: 1;
			display: flex;
			flex-direction: row;
			.button {
				flex: 1;
				height: 2.2rem;
				font-size: 0.6rem;
				color: #ffffff;
				text-align: center;
				line-height: 2.2rem;
				cursor: pointer;
        overflow: hidden;
			}
			.disabled-cart {
				background: #c3c3c3;
			}
			.active-cart {
				background: $primaryColor;
			}
      .active-sample {
        background: #ff8a00;
      }
			.disabled-buy {
				background: #999999;
			}
			.active-buy {
				background: #000;
			}
		}
	}
	.ui-cart-animation {
		position: fixed;
		top: 50%;
		left: 50%;
	}
  .sample-popup {
    width: 100%;
  }
  .sample-panel {
    background: #fff;
    max-height: 75vh;
    display: flex;
    flex-direction: column;
  }
  .sample-header {
    padding: 0.75rem;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .sample-title {
    font-size: 0.8rem;
    color: #333;
    font-weight: bold;
    line-height: 1rem;
  }
  .sample-subtitle {
    margin-top: 0.2rem;
    color: #777;
    font-size: 0.6rem;
  }
  .sample-header .close {
    font-size: 0.7rem;
    color: #777;
  }
  .sample-body {
    flex: 1;
    overflow-y: auto;
    padding: 0.75rem;
  }
  .sample-goods-name {
    color: #333;
    font-size: 0.7rem;
    line-height: 0.95rem;
    margin-bottom: 0.6rem;
  }
  .sample-warehouse {
    margin-bottom: 0.6rem;
  }
  .sample-warehouse-title {
    margin-bottom: 0.35rem;
    color: #333;
    font-size: 0.65rem;
  }
  .sample-warehouse-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
  }
  .sample-warehouse-list button {
    max-width: 100%;
    padding: 0.3rem 0.45rem;
    overflow: hidden;
    border: 1px solid #d9d9d9;
    border-radius: 0.1rem;
    background: #fff;
    color: #666;
    font-size: 0.6rem;
    line-height: 0.8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sample-warehouse-list button.active {
    border-color: $primaryColor;
    background: $primaryColor;
    color: #fff;
  }
  .sample-warehouse-empty {
    color: #999;
    font-size: 0.6rem;
  }
  .sample-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.6rem 0;
    border-top: 1px solid #f2f2f2;
  }
  .sample-row-info {
    flex: 1;
    min-width: 0;
    padding-right: 0.5rem;
  }
  .sample-spec {
    color: #333;
    font-size: 0.7rem;
    line-height: 0.9rem;
    word-break: break-word;
  }
  .sample-price,
  .sample-stock {
    margin-top: 0.2rem;
    color: #777;
    font-size: 0.6rem;
    line-height: 0.8rem;
  }
  .sample-number {
    display: flex;
    align-items: center;
    width: 5.4rem;
    flex-shrink: 0;
  }
  .sample-number input {
    width: 2.2rem;
    height: 1.4rem;
    padding: 0;
    border: 1px solid #c7c7cd;
    text-align: center;
    font-size: 0.7rem;
    border-radius: 0;
  }
  .sample-control {
    width: 1.4rem;
    height: 1.4rem;
    line-height: 1.4rem;
    text-align: center;
    border: 1px solid #c7c7cd;
    color: #333;
    font-size: 0.8rem;
  }
  .sample-control:first-child {
    border-right: 0;
  }
  .sample-control:last-child {
    border-left: 0;
  }
  .sample-control-disabled {
    opacity: 0.4;
  }
  .sample-error {
    min-height: 1rem;
    padding: 0 0.75rem;
    color: #ff5b57;
    font-size: 0.6rem;
    line-height: 1rem;
  }
  .sample-footer {
    height: 2.2rem;
    display: flex;
    align-items: center;
    border-top: 1px solid #eee;
  }
  .sample-total {
    flex: 1;
    padding-left: 0.75rem;
    color: #333;
    font-size: 0.7rem;
  }
  .sample-total span {
    color: $primaryColor;
    font-weight: bold;
  }
  .sample-buy {
    width: 6.5rem;
    height: 2.2rem;
    line-height: 2.2rem;
    text-align: center;
    color: #fff;
    background: #ff8a00;
    font-size: 0.7rem;
  }
  .kefu_list{
    padding: 15px 15px 0;
    overflow: hidden;
  }
  .kefu_list a{
    display: block;
    float: left;
    margin-right: 30px;
    margin-bottom: 15px;
  }
  .kefu_list a img{
    width: 40px;
    height: 40px;
  }
</style>
